<template>
  <v-card>
    <v-card-title>Staff Member Lookup
      <v-spacer></v-spacer>
      
      <v-text-field
        v-model="search"
        prepend-icon="search"
        label="Search"
        clearable
        single-line
        hide-details>
      </v-text-field>
         <v-dialog v-if="isAdmin" v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">New Staff Member</v-btn>
          </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>



          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.name" name="name" label="Name" type="text" ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.title" name="title" label="Title" type="text" ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.email" name="email" label="Email" type="text" ></v-text-field>
                </v-flex>
                <!-- <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.phone" name="phone" label="Phone" type="text" ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.voicemail" name="voicemail" label="Voicemail" type="text" ></v-text-field>
                </v-flex> -->
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.room" name="room" label="Room" type="text" ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <h3>Departments
                    <v-btn fab dark color="indigo" @click="addDepartmentRow">
                    <v-icon dark>add</v-icon>
                  </v-btn></h3>
                  <v-card v-for="(department, index) in editedItem.departments" :key="`department-${index}`">
                    <v-card-text>
                      <v-layout align-center justify-center row>
                        <v-flex xs12><v-text-field v-model="editedItem.departments[index]" label="Department Name" type="text" filled ></v-text-field></v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>                
                </v-flex>                                                                
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-title>
      <v-data-table
      :headers="headers"
      :items="staff"
      :search="search"
      :items-per-page="50"
      class="elevation-1"
    >

     <template v-if="isAdmin" v-slot:item.action="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
        <v-icon small @click="deleteItem(item)">delete</v-icon>
      </template>
      <template v-slot:item.departments="{ item }">
       <div v-for="department in item.departments" :key="department">
            {{department}}&nbsp;
      </div>
      </template>
      
    </v-data-table>
  </v-card>
</template>

<script>
import firebase from 'firebase';
import { mapState } from 'vuex'

export default {
  name: 'StaffList',
  data () {
    return {
      search:'',
      dialog: false,
      headers: [
        {
          text: 'Name',
          align: 'left',
          value: 'name'
        },
        { text: 'Title',align: 'left', value: 'title' },
        { text: 'Email',align: 'left', value: 'email' },
        // { text: 'Phone', align: 'left', value: 'phone' },
        // { text: 'Voicemail', align: 'left', value: 'voicemail' },
        { text: 'Room',align: 'left', value: 'room' },
        { text: 'Departments',align: 'left', value: 'departments' },
      ],
      staff:[],
      editedIndex: -1,
      editedItem: {
        id:'',
        name:'',
        title:'',
        email:'',
        // phone:'',
        // voicemail:'',
        room:'',
        departments:[]
      },
      defaultItem: {
        id:'',
        name:'',
        title:'',
        email:'',
        // phone:'',
        // voicemail:'',
        room:'',
        departments:[]
      }
    }
  },
  props: {
    
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Staff Member' : 'Edit Staff Member'
    },
    ...mapState({
      loggedIn: state => state.loggedIn,
      isAdmin: state => state.isAdmin
    })
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  mounted: function() {
    //console.log('[Home][mounted]');
    if(this.isAdmin) {this.headers.push({ text: 'Actions', value: 'action', sortable: false });}
    firebase.firestore().collection('staff').orderBy('name').get().then((snapshot) => {
      snapshot.forEach((doc) => {
        //console.log(doc.data());
        let member = doc.data();
        member.id = doc.id;
        this.staff.push(member);
      });
    });
  },
  methods: {
    addDepartmentRow() {
        this.editedItem.departments.push('');
    },

    editItem (item) {
      this.editedIndex = this.staff.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.staff.indexOf(item)
      if(confirm('Are you sure you want to delete this staff member?')) {
        firebase.firestore().collection('staff').doc(this.staff[index].id).delete().then(() => {
          console.log('Removed staff member from firebase');
          this.staff.splice(index, 1);
          //this.$router.push('/');
        }).catch((error) => {
          console.error('error writing doc to firebase: ', error);
        });
        
      }
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedIndex > -1) {  
        firebase.firestore().collection('staff').doc(this.staff[this.editedIndex].id).set(this.editedItem).then((docRef) => {
          console.log('Wrote doc to firebase: ', docRef);
          Object.assign(this.staff[this.editedIndex], this.editedItem);
          this.close()
          //this.$router.push('/');
        }).catch((error) => {
          console.error('error writing doc to firebase: ', error);
        });
        
      } else {
        
        console.log('Submitting new staff member info: ', this.editedItem);
        firebase.firestore().collection('staff').add(this.editedItem).then((docRef) => {
          console.log('Wrote doc to firebase: ', docRef);
          this.staff.push(this.editedItem);
          this.close()
          //this.$router.push('/');
        }).catch((error) => {
          console.error('error writing doc to firebase: ', error);
        });
      } 
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">

</style>
